import * as z from 'zod';

export const GetUserCertificationRequest = /*#__PURE__*/ z.object({
  userCertificationId: z
    .string()
    .describe('ID of the user certification to retrieve.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
});
export const GetUserCertificationResponse = /*#__PURE__*/ z.object({
  _id: z
    .string()
    .describe('User certification ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  revision: z
    .string()
    .regex(/^-?\d+$/, 'Must be a valid Int64 string')
    .describe(
      'Revision number, which increments by 1 each time the user certification is updated.\nTo prevent conflicting changes,\nthe current revision must be passed when updating the user certification.\n\nIgnored when creating a user certification.'
    )
    .optional()
    .nullable(),
  _createdDate: z
    .date()
    .describe('Date and time the user certification was created.')
    .optional()
    .nullable(),
  _updatedDate: z
    .date()
    .describe('Date and time the user certification was last updated.')
    .optional()
    .nullable(),
  userId: z
    .string()
    .describe(
      "ID of the certified user. Set when the certification is created and can't be changed afterward."
    )
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  certificationType: z
    .enum([
      'VELO',
      'WEB_DESIGNER',
      'ACCESSIBILITY',
      'STUDIO_DEVELOPER',
      'STUDIO_DESIGN_LEAGUE',
      'STUDIO_DEV_WEBSITES_LEAGUE',
    ])
    .describe(
      "Type of certification the user holds. Set when the certification is created and can't be changed afterward."
    )
    .optional(),
});
